module.exports = __webpack_public_path__ + "img/maasTitle.655748c0.png";